import BaseModelAPI from '../BaseModelAPI';

export default class ReportNg extends BaseModelAPI {
	static entity = 'newreport2002';
	static entityName = 'reportng';

	constructor() {

		/*APP_MODEL_DEFINITION*/
		this.filterControlCardNumber = '';
		this.filterPartNumber = '';
		this.filterMachine = '';
		this.filterSubprocess = '';
		this.filterCustomer = '';
		this.filterLine = '';
		this.filterPartClassification = '';
		this.filterPeriodDate = '';
		this.tempId = 0;
		this.createdDate = '';
		this.partName = '';
		this.partNumber = '';
		this.controlCardNumber = '';
		this.customerName = '';
		this.partSpecification = '';
		this.shift = '';
		this.lineProduction = '';
		this.machineName = '';
		this.subprocess = '';
		this.partClassification = '';
		this.qtyCase = 0;
		this.qtyNg = 0;
		this.code = '';
		this.name = '';
		this.areaName = '';
		this.isFromUpload = false;
		this.isSavedToBackend = true;
		this.uploadValidationMessage = '';
		this.uploadValidationStatus = '';
		/*END_APP_MODEL_DEFINITION*/
	}

}